import querystring from "query-string";
import { useFetch } from "lib/useFetch";

// @POC @Deprecated
export const usePocGetPublications = (querystr) => {
  const url = getPublicationUrl(querystr);
  const [data, isLoading, error] = useFetch(url, undefined, "GET");
  const publications = data && data.hits ? tryParse(data) : [];
  // console.info("pubs received", publications);
  return [publications, isLoading, error];
};

const tryParse = (data) => {
  try {
    return data.hits.hits.map((pub) => pub._source);
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getPublicationUrl = (querystr) => {
  const q = mergeKeyword(querystr);
  const search = q ? querystring.stringify({ q }) : "";
  return "/research/jsapi/publications/_search?" + search;
};

const mergeKeyword = (querystr) => {
  let { keyword = "", q = "" } = querystring.parse(querystr);
  if (!keyword && !q) return null;
  if (keyword) {
    q = q ? keyword + " OR " + q : keyword;
  }
  return q;
};
